/**
 * The job/customer fields a WhatsApp template variable can be mapped to. The
 * config tab shows these as the options per template placeholder; the server's
 * reminder composer (pb_hooks/lib/customer-reminders-core.js) resolves the
 * chosen key from the customer's jobs when it queues a message — keep both
 * lists in step. Keep the keys stable — they're persisted in the template
 * config's `variables` map.
 */
export interface WhatsAppTemplateField {
  key: string
  label: string
}

export const whatsappTemplateFields: WhatsAppTemplateField[] = [
  { key: 'customer_first_name', label: 'Customer first name' },
  { key: 'customer_full_name', label: 'Customer full name' },
  { key: 'customer_phone', label: 'Customer phone' },
  { key: 'job_public_id', label: 'Public ID' },
  { key: 'job_number_tag', label: 'Job tag' },
  { key: 'device_type', label: 'Device type' },
  { key: 'job_fault', label: 'Reported fault' },
  // Meant for the several-jobs templates; also valid (count 1) for single jobs.
  { key: 'job_count', label: 'Number of jobs' },
  { key: 'job_list', label: 'List of jobs (device and ID)' },
]

export function whatsappTemplateFieldLabel(key: string): string {
  return whatsappTemplateFields.find((field) => field.key === key)?.label ?? key
}
